<div class="cart-dropdown">
  <!-- Cart Icon Button -->
  <button (click)="toggleDropdown()" class="cart-icon-btn">
    <span class="pi pi-shopping-cart"></span>
    @if (cartService.itemsCount() > 0) {
      <span class="cart-badge">{{ cartService.itemsCount() }}</span>
    }
  </button>

  <!-- PrimeNG Drawer (slide-out panel) -->
  <p-drawer
    [(visible)]="isOpen"
    position="right"
    [modal]="true"
    [blockScroll]="true"
    [closeOnEscape]="true"
    [dismissible]="true"
    styleClass="cart-drawer"
    (onHide)="onDrawerHide()">

    <!-- Custom header -->
    <ng-template #header>
      <h3 class="header-title">
        {{ 'client.cart.title' | translate }}
        ({{ cartService.itemsCount() }})🐾
      </h3>
    </ng-template>

    <!-- Content -->
    @if (cartService.loading() && !cartService.cart()) {
      <div class="loading-state">
        <p>{{ 'client.cart.loading' | translate }}</p>
      </div>
    }

    @if (!cartService.loading() && cartService.isEmpty()) {
      <div class="empty-state">
        <p>{{ 'client.cart.empty' | translate }}</p>
      </div>
    }

    @if (!cartService.isEmpty() && cartService.cart()) {
      <div class="cart-items-list">
        @for (item of cartService.cart()?.items; track item.id) {
          <div class="cart-item" [class.item-updating]="cartService.loadingItemId() === item.id">
            <div class="item-image">
              <app-product-preview-image
                [src]="item.image_url"
                [fallback]="item.thumbnail_url"
                [alt]="item.project_product.display_name"
              />
            </div>

            <div class="item-content">
              <div class="item-header">
                <p class="item-name">
                  {{ item.project_product.display_name }}
                </p>
                <div class="item-actions-icons">
                  @if (item.project_product.project_id) {
                    <button
                      class="edit-btn"
                      (click)="onEditItem(item)"
                      title="Edytuj projekt">
                      <i class="pi pi-pencil"></i>
                    </button>
                  }
                  <button
                    class="delete-btn"
                    (click)="onRemoveItem(item)"
                    [disabled]="cartService.loadingItemId() === item.id"
                    aria-label="Remove item">
                    <i class="pi pi-trash"></i>
                  </button>
                </div>
              </div>

              <div class="item-actions">
                <div class="quantity-control">
                  <button
                    class="qty-btn"
                    (click)="onQuantityChange(item, item.quantity - 1)"
                    [disabled]="item.quantity <= 1 || cartService.loadingItemId() === item.id">
                    <i class="pi pi-minus"></i>
                  </button>
                  <input
                    class="qty-value"
                    type="number"
                    inputmode="numeric"
                    min="1"
                    #qtyInput
                    [value]="item.quantity"
                    [disabled]="cartService.loadingItemId() === item.id"
                    (change)="onQuantityInputChange(item, $event)"
                    (focus)="qtyInput.select()"
                  />
                  <button
                    class="qty-btn"
                    (click)="onQuantityChange(item, item.quantity + 1)"
                    [disabled]="cartService.loadingItemId() === item.id">
                    <i class="pi pi-plus"></i>
                  </button>
                </div>
                <span class="item-price">{{ item.total_price | currency:cartService.currency() }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    }

    <!-- Footer (always registered, content conditionally shown) -->
    <ng-template #footer>
      @if (!cartService.isEmpty() && cartService.cart()) {
        <div class="panel-footer">
          <div class="summary-section">
            <div class="summary-row">
              <span class="summary-label">{{ 'client.cart.cart_value' | translate }}</span>
              <span class="summary-value">{{ cartService.subtotal() | currency:cartService.currency() }}</span>
            </div>
            <div class="summary-notes">
              <p>{{ 'client.cart.taxes_included' | translate }}</p>
              <p>{{ 'client.cart.shipping_next_step' | translate }}</p>
            </div>
          </div>

          <div class="cta-section">
            <app-button
              (click)="closeDropdown()"
              [routerLink]="i18n.generateUrlWithLang('checkout')"
              [label]="'client.cart.go_to_order' | translate"
              [fullWidth]="true"
              color="primary">
            </app-button>
          </div>
        </div>
      }
    </ng-template>
  </p-drawer>
</div>

